export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

/**
 * Exponential backoff delay for a retry attempt, capped at 4s: 1s → 2s → 4s.
 */
export const getRetryDelay = (attempt: number): number => Math.min(1000 * 2 ** (attempt - 1), 4000);
